import _classCallCheck from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @module ol/layer/Tile
 */
import BaseTileLayer from './BaseTile.js';
import CanvasTileLayerRenderer from '../renderer/canvas/TileLayer.js';
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */

var TileLayer =
/*#__PURE__*/
function (_BaseTileLayer) {
  _inherits(TileLayer, _BaseTileLayer);

  /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */
  function TileLayer(options) {
    _classCallCheck(this, TileLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(TileLayer).call(this, options));
  }

  _createClass(TileLayer, [{
    key: "createRenderer",
    value: function createRenderer() {
      return new CanvasTileLayerRenderer(this);
    }
  }]);

  return TileLayer;
}(BaseTileLayer);

export default TileLayer;